import logo from "../img/icon.png";
import logoSvg from "../img/logo.svg";
const AppLogo = logo;
const AppLogoSvg = logoSvg;
const sProducts = "products";
const sUsers = "users";
const sOrders = "orders";
const sName = "name";
const sTimestamp = "timestamp";
const sFeed = "feed";
const sSort = "sort";
const sOperate = "Actions";
const sCategory = "category";
const sOnOff = "On/Off";
const sFeedMgt = "Feed Management";
const sHeading = "heading";
export {
  sOperate,
  sHeading,
  AppLogoSvg,
  sCategory,
  sFeedMgt,
  sOnOff,
  sProducts,
  sUsers,
  AppLogo,
  sOrders,
  sName,
  sTimestamp,
  sFeed,
  sSort,
};
